import React from "react";
import { Redirect, Route } from "react-router";
import { Switch } from "react-router-dom";

// import Group from "./group-routes";
// import Role from "./role-routes";
// import User from "./user-routes";
import Dashboard from "./dashboard-routes";
import Map from "./views/map";
import Alerts from "./views/alerts";
import Help from "./views/help";

// import MainPage from "./main-page";
import LoginPage from "./login-page";
// import SignupPage from "./signup-page";

import DrawerLayout from "./drawer-layout";

import LiveData from "./components/livedata/livedata-routes";
// import LiveData from "./components/livedata/livedata";

const Routes = () => (
  <DrawerLayout>
    <Switch>
      {/* <Route path="/group"><Group/></Route> */}
      {/* <Route path="/role"><Role/></Route> */}
      {/* <Route path="/user"><User/></Route> */}
      <Route path="/dashboard">
        <Dashboard />
      </Route>
      <Route path="/map">
        <Map />
      </Route>
      <Route path="/alerts">
        <Alerts />
      </Route>
      <Route path="/help">
        <Help />
      </Route>
      <Route path="/login">
        <LoginPage />
      </Route>
      <Route path="/livedata">
        <LiveData />
      </Route>
      {/* <Route path="/signup"><SignupPage/></Route> */}
      {/* <Route exact path="/"><MainPage/></Route> */}
      <Route exact path="/">
        <Redirect to="/dashboard" />
        {/* loggedIn ? (
            <Redirect to="/dashboard" /> // TODO default user dashboard
          ) : (
            <PublicHomePage />
          ) */}
      </Route>
    </Switch>
  </DrawerLayout>
);
export default Routes;
